import { QueryClient } from "@tanstack/react-query"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 60 * 1000,
    },
  },
})

export const removeProtectedMerchantQueryData = (
  client: Pick<QueryClient, "removeQueries"> = queryClient
) => {
  // Billing and authentication recovery use direct service calls. Clear every
  // query so a newly added merchant-scoped key cannot survive an access denial.
  client.removeQueries()
}

export default queryClient
